import { AppConfig } from '@/constants/AppConfig';
import { useAuthentication } from '@/contexts/dataSync/AuthenticationContext';
import { getRetailerSubdomainUrl } from '@/utilities/RetailerSubdomainUrl';
import { useEffect } from 'react';

export const useRetailerSubdomainRedirect = () => {
  const { isRetailer, retailer } = useAuthentication();

  useEffect(() => {
    if (!isRetailer) {
      return;
    }
    const redirectUrl = getRetailerSubdomainUrl(
      window.location.href,
      retailer?.shortUrlName,
      AppConfig.shortUrlDomain,
    );
    if (redirectUrl) {
      window.location.replace(redirectUrl);
    }
  }, [isRetailer, retailer?.shortUrlName]);
};
